import moment from 'moment'
import * as React from 'react'
import { IAddOn, IProductPricing } from '../../../../../../types/index'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import { Input } from '@mobiscroll/react-latest'

interface IProviderProductPricingsProps {
  pricing: IProductPricing
}

interface IPricingFieldProps {
  title: string
  name: string
  value: string | undefined
  placeholder: string
  className?: string
}

const PricingField = (props: IPricingFieldProps) => (
  <div className={`col-3 pr2 flex flex-column ${props.className}`}>
    <Input
      name={props.name}
      value={props.value}
      type='string'
      readOnly={true}
      className='mobiscroll-input form'
      label={props.title}
      theme='ios'
      themeVariant='light'
      inputStyle='box'
      labelStyle='floating'
    />
  </div>
)

const ProductPricingPane = ({ pricing }: IProviderProductPricingsProps) => {
  if (!pricing) {
    return null
  }
  const {
    basePrice,
    cancellationPrice,
    federalTax,
    stateTax,
    surcharges,
    noShowPrice,
    perMinutePrice,
    perMilePrice,
    baseDistance,
    addOn,
    basePriceAddOnAH,
    minimumMilesAddOnAH,
    perMilePriceAddOnAH,
    perMinutePriceAddOnAH,
    surChargeAddOnAH,
    lateCancellationAddOnAH,
    noShowAddOnAH,
    basePriceAddOnWE,
    minimumMilesAddOnWE,
    perMilePriceAddOnWE,
    perMinutePriceAddOnWE,
    surChargeAddOnWE,
    lateCancellationAddOnWE,
    noShowAddOnWE,
    basePriceAddOnHD,
    minimumMilesAddOnHD,
    perMilePriceAddOnHD,
    perMinutePriceAddOnHD,
    surChargeAddOnHD,
    lateCancellationAddOnHD,
    noShowAddOnHD,
    afterHoursFrom,
    afterHoursUntil
  } = pricing

  return (
    <FloatingForm fullHeight={true}>
      <>
        <div className='form-modal-section full-section'>
          <div className='font-grey2 bold h5 mb1'>Pricing</div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='Base Prices'
              name='basePrice'
              value={!!basePrice ? `$${basePrice / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Minimum miles'
              name='baseDistance'
              value={!!baseDistance ? `${baseDistance}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per mile'
              name='perMilePrice'
              value={!!perMilePrice ? `$${perMilePrice / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per minute'
              name='perMinutePrice'
              value={!!perMinutePrice ? `$${perMinutePrice / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Late cancellation fee'
              name='cancellationPrice'
              value={!!cancellationPrice ? `$${cancellationPrice / 100}` : undefined}
              placeholder='$0.00'
            />
          </div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='No Show Fee'
              name='noShowPrice'
              value={!!noShowPrice ? `$${noShowPrice / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Surcharges'
              name='surcharges'
              value={!!surcharges ? `$${surcharges / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='State tax'
              name='stateTax'
              value={!!stateTax ? `${stateTax / 100} %` : undefined}
              placeholder='0.00 %'
            />
            <PricingField
              title='Federal tax'
              name='federalTax'
              value={!!federalTax ? `${federalTax / 100} %` : undefined}
              placeholder='0.00 %'
            />
            <div className='col-3 pr2' />
          </div>
          <hr className='my2' />
          <div className='font-grey2 bold h5 mb1'>Pricing Weekend</div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='Base Prices'
              name='basePriceAddOnWE'
              value={!!basePriceAddOnWE ? `$${basePriceAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Minimum miles'
              name='minimumMilesAddOnWE'
              value={!!minimumMilesAddOnWE ? `${minimumMilesAddOnWE}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per mile'
              name='perMilePriceAddOnWE'
              value={!!perMilePriceAddOnWE ? `$${perMilePriceAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per minute'
              name='perMinutePriceAddOnWE'
              value={!!perMinutePriceAddOnWE ? `$${perMinutePriceAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Late cancellation fee'
              name='lateCancellationAddOnWE'
              value={!!lateCancellationAddOnWE ? `$${lateCancellationAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
          </div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='No Show Fee'
              name='noShowAddOnWE'
              value={!!noShowAddOnWE ? `$${noShowAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Surcharges'
              name='surChargeAddOnWE'
              value={!!surChargeAddOnWE ? `$${surChargeAddOnWE / 100}` : undefined}
              placeholder='$0.00'
            />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
          </div>
          <hr className='my2' />
          <div className='font-grey2 bold h5 mb1'>Pricing Holidays</div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='Base Prices'
              name='basePriceAddOnHD'
              value={!!basePriceAddOnHD ? `$${basePriceAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Minimum miles'
              name='minimumMilesAddOnHD'
              value={!!minimumMilesAddOnHD ? `${minimumMilesAddOnHD}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per mile'
              name='perMilePriceAddOnHD'
              value={!!perMilePriceAddOnHD ? `$${perMilePriceAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per minute'
              name='perMinutePriceAddOnHD'
              value={!!perMinutePriceAddOnHD ? `$${perMinutePriceAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Late cancellation fee'
              name='lateCancellationAddOnHD'
              value={!!lateCancellationAddOnHD ? `$${lateCancellationAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
          </div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='No Show Fee'
              name='noShowAddOnHD'
              value={!!noShowAddOnHD ? `$${noShowAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Surcharges'
              name='surChargeAddOnHD'
              value={!!surChargeAddOnHD ? `$${surChargeAddOnHD / 100}` : undefined}
              placeholder='$0.00'
            />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
          </div>
          <hr className='my2' />
          <div className='font-grey2 bold h5 mb1'>Pricing After Hours</div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='Base Prices'
              name='basePriceAddOnAH'
              value={!!basePriceAddOnAH ? `$${basePriceAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Minimum miles'
              name='minimumMilesAddOnAH'
              value={!!minimumMilesAddOnAH ? `${minimumMilesAddOnAH}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per mile'
              name='perMilePriceAddOnAH'
              value={!!perMilePriceAddOnAH ? `$${perMilePriceAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Price per minute'
              name='perMinutePriceAddOnAH'
              value={!!perMinutePriceAddOnAH ? `$${perMinutePriceAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Late cancellation fee'
              name='lateCancellationAddOnAH'
              value={!!lateCancellationAddOnAH ? `$${lateCancellationAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
          </div>
          <div className='flex flex-row pt1'>
            <PricingField
              title='No Show Fee'
              name='noShowAddOnAH'
              value={!!noShowAddOnAH ? `$${noShowAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
            <PricingField
              title='Surcharges'
              name='surChargeAddOnAH'
              value={!!surChargeAddOnAH ? `$${surChargeAddOnAH / 100}` : undefined}
              placeholder='$0.00'
            />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
            <div className='col-3 pr2' />
          </div>
          <hr className='mt1' />
          <div className='font-grey2 bold h6'>After Hours Time Range</div>
          <section className='pt1'>
            <div className='flex flex-row items-center mt02'>
              <PricingField
                title='From'
                name='from'
                value={moment(afterHoursFrom).isValid() ? moment(afterHoursFrom).format('hh:mmA') : 'None Set'}
                placeholder=''
              />
              <PricingField
                title='Until'
                name='until'
                value={moment(afterHoursUntil).isValid() ? moment(afterHoursUntil).format('hh:mmA') : 'None Set'}
                placeholder=''
              />
              <div className='col-3 pr2' />
              <div className='col-3 pr2' />
              <div className='col-3 pr2' />
            </div>
          </section>
          {addOn && addOn.length > 0 && (
            <section className='pt2'>
              <div className='font-grey2 bold h5 mb1'>Add Ons</div>
              <div>
                {addOn.map((item: IAddOn) => {
                  const price = (item.price ? item.price : 0) / 100

                  return (
                    <span className='product-item' key={item.label} style={{ whiteSpace: 'nowrap' }}>
                      {item.label} ( ${price.toFixed(2)} )
                    </span>
                  )
                })}
              </div>
            </section>
          )}
        </div>
      </>
    </FloatingForm>
  )
}

export default ProductPricingPane



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/pane/ProductPricing.tsx